module.exports = __webpack_public_path__ + "media/images/down-9b209c42f11fe7a30c2cfcbe6a4e90ff.png";